import { defineStore } from "pinia";
import axios from "axios";

export const useAuthenicationStore = defineStore({
	id: "authenication",
	persist: true,
	state: () => ({
		runSiteInfo: {},
	}),
	actions: {
		async getAccountApi(token) {
			await axios
				.get(
					process.env.VUE_APP_BASE_URL_API + "app/authentication/getAccount",
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then((response) => {
					// console.log(response);

					this.runSiteInfo = {
						runSiteName: response.data.campaignName,
						eventName: "tff2025",
						province: response.data.province,
					};
				});
		},
		// async sendReportApi(data, token) {
		// 	return new Promise((resolve, reject) => {
		// 		axios
		// 			.post(
		// 				process.env.VUE_APP_BASE_URL_API + "app/report/sendReport",
		// 				data,
		// 				{
		// 					headers: {
		// 						Authorization: `Bearer ${token}`,
		// 					},
		// 				}
		// 			)
		// 			.then((response) => {
		// 				resolve(response.data);
		// 			})
		// 			.catch((error) => reject(error));
		// 	});
		// },
		async getSummaryApi(data, token) {
			return new Promise((resolve, reject) => {
				axios
					.get(
						process.env.VUE_APP_BASE_URL_API +
							`app/report/getRunSiteSummary?runSiteId=${data.runSiteId}&eventName=${data.eventName}`,
						{
							headers: {
								Authorization: `Bearer ${token}`,
							},
						}
					)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => reject(error));
			});
		},
		async authenticateRefundLoginApi(data, token) {
			return new Promise((resolve, reject) => {
				axios
					.post(
						process.env.VUE_APP_BASE_URL_API +
							"app/authentication/authenticateRefundLogin",
						data,
						{
							headers: {
								Authorization: `Bearer ${token}`,
							},
						}
					)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => reject(error));
			});
		},
		async resetPasswordApi(data) {
			return new Promise((resolve, reject) => {
				axios
					.post(
						process.env.VUE_APP_BASE_URL_API +
							"app/authentication/resetPassword",
						data
					)
					.then((response) => {
						resolve(response.data);
					})
					.catch((error) => reject(error));
			});
		},
	},
});
